import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { PopupMessageSummaries, PopupMessageTypes } from '../dictionaries';
import { FileHolder, MailMessage, MessageInfo, MessageType, ServerResponse } from '../models';
import { AccountService } from './account.service';
import { AppConfig } from './app.config';
import { PopupService } from './popup.service';
import { RestService } from './rest.service';


@Injectable()
export class MailService {

  constructor(
    private restService: RestService,
    private popupService: PopupService,
    private accountService: AccountService
  ) { }
  private sendedOneTime = false;

  public sendMessage(messageType: MessageType, attachments: File[], text: string = null, header: string = null):
    Promise<ServerResponse<any>> {

    return new Promise<ServerResponse<any>>(resolve => {
      this.accountService.getCredentialsPromise().then(cred => {
        if (!cred.EMail) {
          const messageComplite = new MessageInfo();
          messageComplite.severity = PopupMessageTypes.Info;
          messageComplite.summary = PopupMessageSummaries.Info;
          messageComplite.detail = 'Укажите в профиле адрес электронной почты.';
          this.popupService.showMessage(messageComplite);
          return;
        }

        const mailData = new MailMessage();
        mailData.AppId = AppConfig.config.AppId;
        mailData.MessageType = messageType;
        mailData.ReceiverId = cred.Id_User;
        mailData.SessionId = cred.Id_Session;
        mailData.Signature = AppConfig.config.HashSalt;
        mailData.MessageText = text;

        const promises: Promise<null>[] = [];
        Array.from(attachments).forEach(file => {
          promises.push(new Promise<null>(res => {
            this.convertFile(file).then(resp => {
              mailData.Attachments.push(resp);
              res();
            });
          }));
        });
        Promise.all(promises).then(n => {
          this.restService.sendEmail(mailData).then(response => {
            if (response.Result.ReturnCode >= 0) {
              resolve(response);
              return;
            }
          });
        });
      });
    });
  }

  public convertFile(file: File): Promise<FileHolder> {
    return new Promise<FileHolder>(resolve => {
      const myReader: FileReader = new FileReader();
      myReader.onloadend = (e) => {
        const fileHolder = new FileHolder();
        fileHolder.Data = myReader.result;
        fileHolder.Name = file.name;

        resolve(fileHolder);
      };
      myReader.readAsDataURL(file);
    });
  }

  public sendSinglePdf(messageType: MessageType, attachments: any[], titleOfPDF: string): Promise<string> {
    return new Promise<string>((resolve, error) => {
      this.accountService.getCredentialsPromise().then(cred => {
        if (!cred.EMail) {
          error();
        }

        if (!this.sendedOneTime) {

          const mailData = new MailMessage();
          mailData.AppId = AppConfig.config.AppId;
          mailData.MessageType = messageType;
          mailData.ReceiverId = cred.Id_User;
          mailData.SessionId = cred.Id_Session;
          mailData.Signature = AppConfig.config.HashSalt;

          const promises: Promise<FileHolder>[] = [];
          Array.from(attachments).forEach(file => {
            promises.push(new Promise<null>(res => {
              this.convertPDFstring(file, titleOfPDF).then(resp => {
                mailData.Attachments.push(resp);
                res();
              });
            }));
          });
          Promise.all(promises).then(next => {
            this.sendedOneTime = true;
            this.restService.sendEmail(mailData).then(response => {
              this.sendedOneTime = false;
              if (response.Result.ReturnCode > 0) {
                resolve();
              }
            });
          });
        }
      });
    });
  }

  public convertPDFstring(stringOfPdf: string, titleOfPdf: string): Promise<FileHolder> {
    return new Promise<FileHolder>(resolve => {
      const fileHolder = new FileHolder();
      fileHolder.Data = stringOfPdf;
      fileHolder.Name = titleOfPdf;
      resolve(fileHolder);
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/mail.service.ts